
import {FC} from "react";

import React from 'react';

import CheckToImplementForm from "../../forms/claim-handling-forms/check-to-implement-form";

interface Interface{
    partSource: any;
    requestId: any;
    mode?: "View" | "Add new";
    onClose?: () => void;
}



const CheckToImplementScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <CheckToImplementForm
                    requestId={props.requestId}
                    partSource={props.partSource}
                    mode={props.mode}
                />
            
    );
}
export default CheckToImplementScreen;
